import { FC } from "react";
import { ISvgProps } from "common/models/components/ui/ISvgProps";

export const SvgUserCircle: FC<ISvgProps> = (props) => {
  return (
    <svg
      {...props}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M16 20C18.7614 20 21 17.7614 21 15C21 12.2386 18.7614 10 16 10C13.2386 10 11 12.2386 11 15C11 17.7614 13.2386 20 16 20Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M7.97461 24.9218C8.72787 23.4408 9.87626 22.1971 11.2926 21.3284C12.709 20.4598 14.3382 20 15.9997 20C17.6613 20 19.2904 20.4598 20.7068 21.3284C22.1232 22.1971 23.2716 23.4407 24.0248 24.9217"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
